<template>
  <div class="min-h-[60vh] bg-[#f6f7f9] flex items-center justify-center px-6 py-16">
    <div class="max-w-[480px] w-full bg-white rounded-2xl border border-[#e9eaec] shadow-sm p-8 sm:p-10">

      <template v-if="done">
        <div class="w-14 h-14 rounded-full bg-[#e9f9ef] flex items-center justify-center mx-auto mb-5">
          <i class="bi bi-check-lg text-[1.6rem] text-[#1db954]" aria-hidden="true"></i>
        </div>
        <h1 class="text-[1.4rem] font-extrabold text-[#111] text-center mb-2">Je bent afgemeld</h1>
        <p class="text-[#666] text-center">Je ontvangt geen nieuwsbrief meer van Plug2Charge. Jammer dat je gaat - je bent altijd welkom terug.</p>
      </template>

      <template v-else>
        <h1 class="text-[1.4rem] font-extrabold text-[#111] mb-2">Nieuwsbrief afmelden</h1>
        <p class="text-[#666] text-[0.95rem] mb-6">Vul je e-mailadres in om je af te melden voor onze nieuwsbrief.</p>

        <form class="flex flex-col gap-3" @submit.prevent="submit" novalidate>
          <input
            v-model="email" type="email" required autocomplete="email" placeholder="je@e-mail.nl"
            aria-label="E-mailadres"
            class="h-[50px] px-4 rounded-[10px] border-2 border-[#e9ecef] text-[1rem] outline-none focus:border-[#FFD500] transition-colors"
          />
          <p v-if="error" class="text-[0.875rem] text-[#d33]" role="alert">{{ error }}</p>
          <button type="submit" :disabled="loading"
            class="h-[52px] rounded-[10px] bg-[#111] hover:bg-[#333] text-white font-bold text-[1rem] transition-colors disabled:opacity-60">
            {{ loading ? 'Bezig…' : 'Afmelden' }}
          </button>
        </form>
      </template>

    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const email = ref('')
const loading = ref(false)
const done = ref(false)
const error = ref('')

async function submit() {
  error.value = ''
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
    error.value = 'Vul een geldig e-mailadres in.'
    return
  }
  loading.value = true
  try {
    const res = await fetch('/api/newsletter-unsubscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: email.value.trim() }),
    })
    if (!res.ok) {
      const data = await res.json().catch(() => ({}))
      throw new Error(data.error || 'Afmelden mislukt. Probeer het opnieuw.')
    }
    done.value = true
  } catch (e) {
    error.value = e.message
  } finally {
    loading.value = false
  }
}
</script>
